import React from 'react';
import { RadioInput } from '../../Helpers/Inputs';
import { Card, CardContent } from '@material-ui/core';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './ScheduleTime.scss';

export default function ScheduleTime({ classes, onClickSlot, register, appointmentTimes }) {
  return (
    <React.Fragment>
      <div className={appointmentTimes.length > 0 ? 'code-block' : ''}>
        {appointmentTimes.map((item, i) => {
          return (
            <Card className={`mt-2 appointment-time-card ${item.isRadioSelect ? classes.bgColor : ''}`} key={i} onClick={(e) => onClickSlot(item.label)}>
              <CardContent className="py-0">
                <Row className="appointment-time justify-content-center align-items-center">
                  <Col xs={8} sm={10}>
                    <h5 className={`${classes.textColor} mb-0`}>{item.label}</h5>
                  </Col>
                  <Col xs={4} sm={2} className="apt-time-div">
                    <div className="pt-3">
                      <RadioInput
                        name="specificApptTime"
                        id="specificApptTime"
                        label=""
                        value={item.label}
                        radios={[{ value: item.isRadioSelect && item.label, label: '' }]}
                        inputRef={register}
                      />
                    </div>
                  </Col>
                </Row>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </React.Fragment>
  );
}

ScheduleTime.propTypes = {
  classes: PropTypes.object,
  onClickSlot: PropTypes.func,
  register: PropTypes.func,
  appointmentTimes: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    isRadioSelect: PropTypes.bool,
  }))
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Common/ScheduleTimeCard.js